// @flow
import React, { PureComponent } from 'react';
import CardAcademie from 'components/fragments/card/CardAcademie';
import type { AcademiePreviewType } from 'types/Academie';
import { CENTRE_RUGBY_LAT, CENTRE_RUGBY_LONG } from 'constants/clubConstants';
import OpenStreetMap from 'components/fragments/map/OpenStreetMap';
import { dynamicClassName } from 'utils/dynamicClassName';
import { MOBILE_SIZE } from 'constants/app';

export type StateProps = {
  academies: Array<AcademiePreviewType>,
};

type Props = {
  academies: Array<AcademiePreviewType>,
} & StateProps;

type State = {
  userLatitude: number,
  userLongitude: number,
  toggleMap: boolean,
  academieClicked: number,
  zoom: number,
  bannerHeight: number,
  containerHeight: number,
  mapHeight: number,
  mapSticky: boolean,
  mapFullHeight: boolean,
};

class AcademieListing extends PureComponent<Props, State> {
  state: State = {
    userLatitude: CENTRE_RUGBY_LAT,
    userLongitude: CENTRE_RUGBY_LONG,
    zoom: 6,
    toggleMap: false,
    academieClicked: -1,
    bannerHeight: 0,
    containerHeight: 0,
    mapHeight: 0,
    mapSticky: false,
    mapFullHeight: false,
  };
  _list: ?HTMLElement

  handleClick(index:number) {
    const {lat, lon} = this.props.academies[index];
    this.setState({userLatitude: lat, userLongitude: lon, academieClicked: index});
  }

  componentDidMount() {
    const bannerHeight = this.getSizeOf('.banner--map', 'client');
    const containerHeight = this.getSizeOf('.result-academies', 'offset');
    const mapHeight = this.getSizeOf('.result-club__maps', 'client');
    this.setState({bannerHeight, containerHeight, mapHeight});
    window.addEventListener('scroll', this.onScrollPosition);
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScrollPosition);
    window.removeEventListener('resize', this.onResize);
  }

  /**
   * Au resize : 
   * Recalculer les tailles des éléments qui sont stockés dans les états
   */
  onResize = () => {
    const bannerHeight = this.getSizeOf('.banner--map', 'client');
    const containerHeight = this.getSizeOf('.result-academies', 'offset');
    const mapHeight = this.getSizeOf('.result-club__maps', 'client');
    this.setState({bannerHeight, containerHeight, mapHeight});
  }

  getSizeOf = (classname: string, type: string) : number => {
    if (document.querySelector(classname)) {
      if (type === 'client') {
        // $FlowFixMe
        return document.querySelector(classname).clientHeight;
      }
      // $FlowFixMe
      return document.querySelector(classname).offsetHeight;
    }
    return 0;
  }
  /**
   * Au scroll :
   * - Si > à la taille de la bannière la map a une class sticky qui la fait scroller
   * - Si > à la taille du conteneur moins la bannière (bas de page) :
   *   - la map perd sa class sticky
   *   - la map récupère une class fullheight qui la bloque en bas de page
   * - Sinon, pas de sticky ni fullheight
   */
  onScrollPosition = () => {
    const distanceScrolled = window.scrollY || window.pageYOffset;
    if (distanceScrolled > this.state.bannerHeight) {
      this.setState({mapSticky: true, mapFullHeight: false});
      if (distanceScrolled > this.state.containerHeight - this.state.bannerHeight) {
        this.setState({mapSticky: false, mapFullHeight: true});
      }
    } else {
      this.setState({mapSticky: false, mapFullHeight: false});
    }
  }

  displayAcademiesPreview = (academies: Array<AcademiePreviewType>): any => {
    return academies.map((academie, index) => (
      <div
        onClick={this.handleClick.bind(this, index)}
        key={academie.name}
        role="button"
        tabIndex={0}>
        <CardAcademie
          academie={academie}
          position={index + 1}
        />
      </div>
    ));
  };

  renderMapComponent = () => (
    <OpenStreetMap
      width={'425'}
      height={'100%'}
      long={this.state.userLongitude}
      lat={this.state.userLatitude}
      zoom={this.state.zoom}
      openPopup={this.state.academieClicked}
      academies={this.props.academies} /> 
  );

  renderMap = () => {
    if (window.innerWidth < MOBILE_SIZE) {
      if (this.state.toggleMap) {
        return this.renderMapComponent();
      }

      return null;
    }

    return this.renderMapComponent();
  }

  toggleMap = () => {
    this.setState({
      toggleMap: !this.state.toggleMap
    });
  }

  render() {
    const displayedAcademies = this.props.academies;

    const divClassName = dynamicClassName("result-academies");
    this.state.toggleMap && divClassName.add('has-map');

    const mapClassName = dynamicClassName("result-club__maps");
    this.state.mapSticky && mapClassName.add('sticky');
    this.state.mapFullHeight && mapClassName.add('fullheight');

    return (
      <React.Fragment>
        <div className="col col-md-7 col-lg-5 result-club__list">
          <div className="result-club__header clearfix mt-2 mt-md-4 mt-lg-5 mb-2 mb-md-4">
            <span
              role="button"
              tabIndex={0}
              className="btn btn--primary js-toggleMap"
              onClick={this.toggleMap}>
              <i className="icon icon-place is-inline" />
              <span>Carte</span>
            </span>
            <p className="ft-h6 ft-up">{this.props.academies.length} academie(s) trouvée(s)</p>
          </div>
          {this.displayAcademiesPreview(displayedAcademies)}
        </div>
        <div className={mapClassName.build()}>
          <span
            role="button"
            tabIndex={0}
            className="btn btn--primary js-toggleMap"
            onClick={this.toggleMap}
            style={{zIndex: 20}}>
            <i className="icon icon-list is-inline" />
            <span>Liste</span>
          </span>
          {this.renderMap()}
        </div>
      </React.Fragment>
    );
  }
}

export default AcademieListing;
